import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Moment from 'moment';
import { getSalesPerformancePerSales } from 'src/services/SalesPerformance/SalesPerformance';
import {
  CButton,
  CCard,
  CCol,
  CHeader,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow
} from '@coreui/react';
import { DateRangePicker } from 'react-date-range';
import SummaryDownload from '../summary/Download/Summary';
import ls from 'local-storage';

import { getMerchantList } from 'src/services/MerchantList/MerchantList';

function SalesPerformanceDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const salesID = location.state.salesID;

  const [chartLineLabel, setChartLineLabel] = useState([]);
  const [chartLineData, setChartLineData] = useState([]);

  const [summaryData, setSummaryData] = useState([]);

  const [byDeals, setByDeals] = useState([]);
  const [byPackage, setByPackage] = useState([]);
  const [byPos, setByPos] = useState([]);
  const [drModal, setDrModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [mapsMarker, setMapsMarker] = useState([]);
  const [dataMerchant, setDataMerchant] = useState([]);

  const endDay = Moment(new Date()).format('YYYY-MM-DD');
  const max = new Date(endDay);

  const [dateRange, setDateRange] = useState([
    {
      // startDate: ls.get("dateRange") ? new Date(ls.get("dateRange").startDate) : new Date(`${Moment(new Date()).startOf('month').format("MMM dd YYYY")}`),
      startDate: new Date(`${Moment(new Date()).startOf('month')}`),
      endDate: new Date()
    }
  ]);
  // endDate: ls.get("dateRange") ? new Date(ls.get("dateRange").endDate) : new Date()}])

  async function fetchSummary(from, to, id) {
    const response = await getSalesPerformancePerSales(from, to, id);

    if (
      response['visits'] !== undefined &&
      response['visits'] !== null &&
      response['visits'].length > 0
    ) {
      const forMaps = response['visits'].map((item) => {
        return {
          lat: parseFloat(item.latitude),
          lng: parseFloat(item.longitude)
        };
      });
      const data = response['visits'].map((item) => {
        return {
          merchantName: item.merchant_name,
          address: item.address,
          businessType: item.business_type,
          visitDate: Moment(new Date(item.created_at)).format('YYYY-MM-DD')
        };
      });

      setDataMerchant(data);
      setMapsMarker(forMaps);
    } else {
      setMapsMarker([]);
      setDataMerchant([]);
    }

    if (response['package'].length > 0 && response['package'] !== undefined) {
      const data = response['package'].map((item) => {
        if (item.package_type === '0') {
          return { count: item.count, package_type: 'Tidak Tertarik' };
        } else if (item.package_type === '1') {
          return { count: item.count, package_type: 'Trial' };
        } else if (item.package_type === '2') {
          return { count: item.count, package_type: 'Free' };
        } else if (item.package_type === '3') {
          return { count: item.count, package_type: 'Lite' };
        } else if (item.package_type === '4') {
          return { count: item.count, package_type: 'Business' };
        } else if (item.package_type === '5') {
          return { count: item.count, package_type: 'Professional' };
        } else {
          return { count: item.count, package_type: 'Lainnya' };
        }
      });
      setByPackage(data);
    } else {
      setByPackage([]);
    }

    if (response['pos'].length > 0 && response['pos'] !== undefined) {
      const data = response['pos'].map((item) => {
        let returnedItem = item;
        if (item.current_pos === '0') {
          returnedItem.current_pos = 'Belum Pakai POS';
        } else if (item.current_pos === '1') {
          returnedItem.current_pos = 'Moka';
        } else if (item.current_pos === '2') {
          returnedItem.current_pos = 'Majoo';
        } else if (item.current_pos === '3') {
          returnedItem.current_pos = 'Olsera';
        } else if (item.current_pos === '4') {
          returnedItem.current_pos = 'iSeller';
        } else if (item.current_pos === '5') {
          returnedItem.current_pos = 'Pawoon';
        } else if (item.current_pos === '6') {
          returnedItem.current_pos = 'FolioPOS';
        } else if (item.current_pos === '7') {
          returnedItem.current_pos = 'Youtap';
        } else if (item.current_pos === '1000') {
          returnedItem.current_pos = 'Spots';
        } else if (item.current_pos === '1001') {
          returnedItem.current_pos = 'Loyverse';
        } else if (item.current_pos === '1002') {
          returnedItem.current_pos = 'Quinos';
        } else if (item.current_pos === '1003') {
          returnedItem.current_pos = 'Qasir';
        } else if (item.current_pos === '1004') {
          returnedItem.current_pos = 'POST';
        } else if (item.current_pos === '1005') {
          returnedItem.current_pos = 'Mille';
        } else if (item.current_pos === '1006') {
          returnedItem.current_pos = 'Luna POS';
        } else if (item.current_pos === '1007') {
          returnedItem.current_pos = 'Cash Register';
        } else if (item.current_pos === '1008') {
          returnedItem.current_pos = 'Kasir Pintar';
        } else if (item.current_pos === '1009') {
          returnedItem.current_pos = 'Gobiz';
        } else if (item.current_pos === '1010') {
          returnedItem.current_pos = 'ESB';
        } else if (item.current_pos === '1011') {
          returnedItem.current_pos = 'DRetail';
        } else {
          returnedItem.current_pos = 'Lainnya';
        }
        return returnedItem;
      });
      setByPos(data);
    } else {
      setByPos([]);
    }

    if (response['visitByDate'] !== null) {
      const label = response['visitByDate'].map((item) => {
        return item.date.slice(5).replace('-', '/');
      });

      const data = response['visitByDate'].map((item) => {
        return item.counter;
      });

      setChartLineLabel(label);
      setChartLineData(data);
    } else {
      setChartLineData([]);
      setChartLineLabel([]);
    }

    setSummaryData(response);

    setByDeals(response['deals']);
  }

  function toSQLDateFormat(date) {
    return Moment(new Date(date)).format('YYYY-MM-DD');
  }

  useEffect(() => {
    if (!salesID) {
      navigate(-1);
    } else {
      const newStartDay = toSQLDateFormat(dateRange[0].startDate);
      const newEndDay = toSQLDateFormat(dateRange[0].endDate);

      fetchSummary(newStartDay, newEndDay, salesID);
    }
  }, [refetch, dateRange]);

  return (
    <>
      <CModal
        visible={drModal}
        style={{
          width: 'fit-content'
        }}
        onClose={() => {
          setDrModal(false);
        }}
      >
        <CModalHeader>
          <CModalTitle>Modal title</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol xs="12" lg="10">
            <DateRangePicker
              onChange={(item) => {
                setDateRange([item.range1]);
                ls.set('dateRange', item.range1);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              maxDate={max}
              ranges={dateRange}
              direction="vertical"
              weekStartsOn={1}
              calendarFocus="backwards"
              preventSnapRefocus={true}
              rangeColors={['#4E5B97']}
            />
          </CCol>
        </CModalBody>
        <CModalFooter>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => {
              setRefetch(true);
              setDrModal(false);
            }}
          >
            OK
          </CButton>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => setDrModal(!drModal)}
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal>
      <CCol xs="12 bg-light">
        <CCol>
          <CButton
            className="ml-3 mb-3 btn btn-dark"
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            hover="true"
            onClick={() => {
              setDrModal(!drModal);
            }}
          >
            <div>
              {Moment(dateRange[0].startDate).format('ll')}
              {' - '}
              {Moment(dateRange[0].endDate).format('ll')}
            </div>
          </CButton>
        </CCol>

        <CCard style={{ padding: '2vh 2vw' }}>
          <CRow>
            <CCol xs={6}>
              <p className="fs-3 fw-bold">DATA PER SALES </p>
            </CCol>

            <CCol xs={6} style={{ textAlign: 'right' }}>
              <SummaryDownload
                dateFrom={toSQLDateFormat(dateRange[0].startDate)}
                dateUntil={toSQLDateFormat(dateRange[0].endDate)}
                byPos={byPos}
                byPackage={byPackage}
                byDeals={byDeals}
                total={summaryData.total}
                totalDeals={summaryData.totalDeal}
                totalPOS={summaryData.totalPOS}
                totalPackage={summaryData.totalPackage}
              />
            </CCol>
          </CRow>
          <div className="mt-3 mb-3">
            <CRow className="text-uppercase fs-6 fw-bolder">
              <span>NAMA SALES: {location.state.salesName}</span>
            </CRow>
            <CRow className="fs-6">
              <span>{location.state.salesEmail}</span>
            </CRow>
            <CRow className="fs-6">
              <span>{location.state.salesPhone}</span>
            </CRow>
          </div>
          <div className="mt-3 mb-3">
            <CRow className="text-uppercase fs-6 fw-bolder">
              <span>Kunjungan</span>
            </CRow>
            {dataMerchant.length > 0 ? (
              <CTable align="middle" className="mb-5 border" hover responsive>
                <CTableHead
                  style={{ backgroundColor: '#4E5B97', color: 'white' }}
                >
                  <CTableRow>
                    <CTableHeaderCell className="text-center">
                      Nama Calon Partner
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Tanggal Kunjungan
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Alamat
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Tipe Bisnis
                    </CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody style={{ backgroundColor: '#fff' }}>
                  {dataMerchant &&
                    dataMerchant.map((item, index) => (
                      <CTableRow v-for="item in tableItems" key={index}>
                        <CTableDataCell className="text-center">
                          {item.merchantName}
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          <div>{item.visitDate}</div>
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          <div>{item.address}</div>
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          <div>{item.businessType}</div>
                        </CTableDataCell>
                      </CTableRow>
                    ))}
                </CTableBody>
              </CTable>
            ) : (
              <CHeader style={{ color: 'silver', marginBottom: '2vh' }}>
                <p style={{ padding: '0vh 0vw 0vh 2vw' }}>
                  Data Tidak Ditemukan
                </p>
              </CHeader>
            )}
          </div>
        </CCard>
      </CCol>
    </>
  );
}

export default SalesPerformanceDetails;
